var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('el-image',{staticClass:"home-img",attrs:{"src":"static/images/homepage.png","fit":"fill"}}),_vm._v(" "),_c('el-image',{staticClass:"home-code",attrs:{"src":"static/images/code.png","fit":"fill"}}),_vm._v(" "),_c('div',{staticClass:"tip"},[_vm._v("扫码或微信搜索【元气森林会员中心】小程序")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1d516828","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = null
// module chunks = 